<div class="home-page-shell pt-5 pb-2 px-2 h-100">
  <div id="app-home" class="main-container d-flex p-2 p-md-3" role="main"
    [attr.aria-label]="('CUSTOMERPAGE' | translate)">
    <div class="inner-container w-100 h-100 d-flex flex-column flex-lg-row overflow-hidden custom-scrollbar">
      <!-- Right Column for Logo -->
      <div
        class="col-xl-8 col-lg-7 col-md-12 d-flex flex-column justify-content-center align-items-center order-1 order-lg-3 custom-scrollbar overflow-xs-visible overflow-sm-visible overflow-md-auto p-sm-2 p-md-3">
        <div class="scroll-wrapper w-100">
          <div class="dsb-container w-100 mx-auto">
            <!-- Headline that appears when columns are wrapping -->
            <div class="d-flex flex-column justify-content-center align-items-center d-lg-none mb-3">
              <!-- Centered Company Logo -->
              <div class="home-company-logo m-3">
                <app-customer-icon></app-customer-icon>
              </div>

              <!-- Row with Two Equal Columns -->
              <div class="d-flex align-items-center">
                <app-avatar [image]="profileService.profile()?.user?.avatar?.url?.responsive || ''"
                  [name]="profileService.profile()?.user?.first_name + ' ' + profileService.profile()?.user?.last_name"
                [type]="'xxl'"></app-avatar>
                <div class="flex-grow-1 ms-3">
                  <app-headline [type]="'h4'" [title]="('HALLO' | translate) + ', ' + profileService.profile()?.user?.first_name"
                  [class]="'mb-1'"></app-headline>
                  <p class="m-0">{{ currentDate | date : 'fullDate' }}</p>
                </div>
              </div>
            </div>
            @if (showIconGrid) {
              <!-- Top Section: Settings Icon -->
              <div class="d-flex align-items-center justify-content-between mb-3 w-100">
                <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">
                    @if(customerService.customerResource()?.home?.dashboard?.show_labels){ {{'HOMEMYWORKPLACE' | translate }} }
                  </app-content>
                @if (capabilities.capabilities().home.user_menu_management) {
                  <app-icon-badge (click)="homeIconsDialog = true;" [style]="'notification'" [icon]="'tune'"
                  [screenReaderText]="'SRMOREOPTIONS' | translate"></app-icon-badge>
                }
              </div>
              <!-- Tab Content for Icons -->
              <div class="tab-content w-100">
                <div class="tab-pane fade show active" role="tabpanel">
                  <div class="row row-cols-3 row-cols-sm-3 row-cols-md-4 row-cols-lg-4 justify-content-center g-4">
                    @for (icon of dashboardMenuItems | slice: (page-1) * 8 : page * 8; track icon.type; let i = $index) {
                      <app-icon-badge 
                        [style]="'home'" 
                        [orientation]="icon.orientation" 
                        [icon]="icon.icon"
                        [color]="icon.color" 
                        [badge]="iconsBadges.get(icon.type) ?? false" 
                        [title]="icon.name | translate"
                        (click)="onDashboardMenuItemClick(icon)"
                        >
                      </app-icon-badge>
                    }
                  </div>
                </div>
              </div>
              <!-- Tab Navigation for Pagination -->
              @if (dashboardMenuItems.length > 8) {
                <div class="d-flex justify-content-center mt-3">
                  <nav [attr.aria-label]="'ICONPAGINATIONARIALABEL' | translate">
                    <ul class="pagination pagination-sm mb-0">
                      <li class="page-item" aria-current="page">
                        <app-link (click)="page = 1;" [title]="'1'" [style]="'pager'" [active]="page === 1">1</app-link>
                      </li>
                      <li class="page-item" aria-current="page">
                        <app-link (click)="page = 2;" [title]="'2'" [style]="'pager'" [active]="page === 2">2</app-link>
                      </li>
                    </ul>
                  </nav>
                </div>
              }
            } @else {
              <div class="d-flex align-items-center justify-content-between mb-2 w-100">
                <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">
                  @if(customerService.customerResource()?.home?.dashboard?.show_labels){{{ 'HOMECOMPANYNEWS' | translate }}}
                </app-content>
                @if(!customerService.customerResource()?.home?.dashboard?.show_labels){
                  <div class="d-flex align-items-center gap-2 text-muted">
                    <span class="text-uppercase small fw-semibold">{{ 'TOPTRENDING' | translate }}</span>
                    <app-icon-badge [style]="'default'" [icon]="'trending_up'"></app-icon-badge>
                  </div>
                }
              </div>
              <app-home-news-tiles
                [tileConfig]="customerService.customerResource()?.home?.dashboard?.tiles ?? []"
                (hasLoadableTilesChange)="onNewsTilesAvailabilityChange($event)"
                class="w-100"
                [class.flex-grow-1]="!customerService.customerResource()?.home?.dashboard?.show_links"
                [class.align-self-stretch]="!customerService.customerResource()?.home?.dashboard?.show_links"
                >
              </app-home-news-tiles>
            }


            <!-- Favorites section -->
            @if (showFavoritesSection) {
              @if(customerService.customerResource()?.home?.dashboard?.show_labels){
                <div class="d-flex align-items-center justify-content-between mt-3 mb-2">
                  <app-content
                    [fontSize]="'fs-verysmall'"
                    [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">
                    {{ 'HOMEMYFAVORITES' | translate }}
                  </app-content>
                </div>
              }

              <app-home-favorites
                class="d-block"
                [class.mt-3]="!customerService.customerResource()?.home?.dashboard?.show_labels"
                [favorites]="userFavorites"
                [icons]="navService.userMenu()"
                [page]="favoritesPage"
                [pageSize]="favoritesPageSize"
                (pageChange)="favoritesPage = $event"
                (favoriteClick)="onFavoriteClick($event)">
              </app-home-favorites>
            }
            <!-- Links section -->
            @if (showLinksSection && dashboardLinks.length > 0) {
              @if(
                customerService.customerResource()?.home?.dashboard?.show_labels ||
                capabilities.capabilities().settings.global_settings
              ){
                <div
                  class="d-flex align-items-center mt-3 mb-2"
                  [class.justify-content-between]="customerService.customerResource()?.home?.dashboard?.show_labels"
                  [class.justify-content-end]="!customerService.customerResource()?.home?.dashboard?.show_labels"
                >

                  @if(customerService.customerResource()?.home?.dashboard?.show_labels){
                    <app-content
                      [fontSize]="'fs-verysmall'"
                      [fontColor]="'text-primary'"
                      [fontDecoration]="'fw-bold'">
                      {{ 'HOMEMYLINKS' | translate }}
                    </app-content>
                  }

                  @if (capabilities.capabilities().settings.global_settings) {
                    <div class="dropdown">
                      <button
                        type="button"
                        class="btn btn-link p-0 text-muted"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        [attr.aria-label]="('SRMOREOPTIONS' | translate)">

                        <app-icon-badge
                          [style]="'notification'"
                          [icon]="'tune'">
                        </app-icon-badge>

                      </button>

                      <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                          <app-link
                            (click)="homeLinkManagerDialog = true;"
                            [title]="('MANAGELINKS' | translate)"
                            [style]="'dropdown'">
                            {{ ('MANAGELINKS' | translate) }}
                          </app-link>
                        </li>

                        <li>
                          <app-link
                            (click)="homeLinkDialog = true;"
                            [title]="('ADDLINK' | translate)"
                            [style]="'dropdown'">
                            {{ ('ADDLINK' | translate) }}
                          </app-link>
                        </li>
                      </ul>
                    </div>
                  }
                </div>
              }
              <div
                [class.mt-3]="
                  !customerService.customerResource()?.home?.dashboard?.show_labels &&
                  !capabilities.capabilities().settings.global_settings
                "
              >
                <app-home-links
                  [links]="dashboardLinks"
                  [page]="pageLinks"
                  [maxPerPage]="maxLinksPerPage"
                  (pageChange)="pageLinks = $event"
                  (linkClick)="openLink($event)">
                </app-home-links>
              </div>
            }
        </div>
      </div>
    </div>
    <!-- Left Column for Form -->
    <div
      class="col-xl-4 col-lg-5 col-md-12 d-flex flex-column justify-content-center align-items-center order-2 order-lg-1">
      <div class="w-100 h-100">
        <div class="dsb-container d-flex flex-column h-100 w-100 mx-auto justify-content-center">
          <!-- Headline that appears when columns are NOT wrapping -->
          <div class="d-none flex-column justify-content-center align-items-center d-lg-flex mb-2 p-2">
            <!-- Company Logo -->
            <div class="home-company-logo m-3">
              <app-customer-icon></app-customer-icon>
            </div>
            <!-- Row with Two Equal Columns -->
            <div class="d-flex align-items-center">
              <app-avatar [image]="profileService.profile()?.user?.avatar?.url?.responsive ?? ''"
                [name]="profileService.profile()?.user?.first_name + ' ' + profileService.profile()?.user?.last_name"
              [type]="'xxl'"></app-avatar>
              <div class="flex-grow-1 ms-3">
                <app-headline [type]="'h5'" [title]="('HALLO' | translate) + ', ' + profileService.profile()?.user?.first_name"
                [class]="'mb-1'"></app-headline>
                <p class="m-0">{{ currentDate | date : 'fullDate' }}</p>
              </div>
            </div>
          </div>
          <!--[class.flex-grow-0]="!showCalendarWidget"-->
          <div class="custom-scrollbar overflow-y-auto flex-grow-0">
            @if (showCalendarWidget) {
              @if(customerService.customerResource()?.home?.dashboard?.show_labels){
                <div class="mb-2">
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">{{ 'HOMEMYEVENTS' | translate }}</app-content>
                </div>
              }
              <app-calendar-widget></app-calendar-widget>
            }
            @if (customerService.customerResource()?.home?.dashboard?.show_notifications && latestNotifications.length > 0) {
              @if(customerService.customerResource()?.home?.dashboard?.show_labels){
                <div class="mb-2">
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">{{ 'HOMEMYLATESTNOTIFICATION' | translate }}</app-content>
                </div>
              }
              <app-notification [notifications]="latestNotifications"
              [intervalMs]="5000" [topN]="5" [favorImportant]="true" (asRead)="markNotificationRead($event)"></app-notification>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

@if (homeIconsDialog) {
  <app-dialog-home-icons [(visible)]="homeIconsDialog"></app-dialog-home-icons>
}
@if (homeLinkDialog) {
  <app-dialog-home-link [visible]="homeLinkDialog" (visibleChange)="onHomeLinkDialogChange($event)"></app-dialog-home-link>
}
@if (homeLinkManagerDialog) {
  <app-dialog-home-link-manager
  [visible]="homeLinkManagerDialog" (visibleChange)="onHomeLinkManagerDialogChange($event)"></app-dialog-home-link-manager>
}

@if (homeLinksAllDialogVisible) {
  <app-dialog-home-links-all
    [visible]="homeLinksAllDialogVisible"
    (visibleChange)="homeLinksAllDialogVisible = $event">
  </app-dialog-home-links-all>
}
